@if (userConfigsFacade.userSignal()) {
  <button mat-icon-button
          class="cx-icon-button-md cx-badge"
          #notificationMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="notificationMenu"
          (menuOpened)="onMenuChange(true)"
          (menuClosed)="onMenuChange(false)"
          data-cy="notification-menu-trigger-button">
    <mat-icon [svgIcon]="isNotificationDropdownOpen() ? 'notification_menu_opened': 'notification_menu_closed'"/>
    @if (layoutFacade.unreadNotificationsCountSignal() > 0) {
      <span class="cx-badge-notification-md-icon remove-badge-border">
        {{ layoutFacade.unreadNotificationsCountForIconSignal() }}
      </span>
    }
  </button>
}

<mat-menu xPosition="before" #notificationMenu="matMenu" class="notification-menu-container">
  <div class="d-flex flex-column notification-menu" *transloco="let t" (click)="$event.stopPropagation()">
    <div class="notification-header d-flex align-items-center pb-m">
      <span class="notification-menu-header ml-xs">{{ t('Notifications') }}</span>
        <div class="ml-auto">
          @if (userConfigsFacade.isExternalViewSignal()) {
            <cw-tooltip [content]="t('Notification settings')">
              <cw-action-icon
                icon="settings"
                font="cortex"
                [routerLink]="notificationsSettingsRoute"
                (click)="notificationMenuTrigger()?.closeMenu()"
                data-cy="notification-menu-trigger-action-icon"/>
            </cw-tooltip>
          }
          <cw-tooltip [content]="t('Mark all as read')">
            <cw-action-icon
              icon="check-circle"
              font="cortex"
              class="ml-xs"
              [disabled]="!notificationsState.hasNotifications()"
              (click)="onMarkAllAsReadClicked()"
              data-cy="mark-all-as-read-action-icon"/>
          </cw-tooltip>
        </div>
    </div>
    <cw-divider/>
    <div class="notifications-list" [class.list-padding]="notificationsState.hasNotifications()">
      @if (notificationsState.hasNotifications()) {
        @for (notification of notificationsState.entities(); track notification.id; let isLast = $last) {
          <app-notification-row class="d-block" [class.row-margin]="!isLast" [notificationData]="notification" [compactMode]="true"/>
        }
      } @else if (notificationsState.isLoading()) {
        <div class="spinner-wrapper p-sm mt-m w-100 d-flex justify-content-center">
          <cw-spinner />
        </div>
      } @else {
        <div class="empty-notifications-container d-flex flex-column justify-content-center align-items-center">
          <mat-icon class="mb-m" svgIcon="no_results_icon"/>
          <span class="font-weight-bold">{{ t('No notifications yet') }}</span>
          <span class="font-s">{{ t('You will see notifications here when they are available.') }}</span>
        </div>
      }
    </div>
    @if (notificationsState.hasNotifications()) {
      <cw-divider/>
      <div class="notification-footer pt-m">
        <span class="small-link pt-m" (click)="onViewAllNotificationsClick()"
          data-cy="view-all-notifications-link">{{ t('View all notifications') }}</span>
      </div>
    }
  </div>
</mat-menu>
